import { useTranslation } from 'react-i18next';
import { isNoInfoUpdate } from '@pperform/pp-utils/parcelOrg';
import Shipment from 'interfaces/PmParcel';
import { useGlobalConfigContext } from 'GlobalConfig.context';
import {
  DEMO_TARGET,
  DEMO_TARGET_ATTRIBUTE,
} from 'constants/demoTarget.constants';

import Typography from 'components/Typography';
import RatingOverall from 'components/RatingOverall';
import EstimatedDeliveryDate from 'components/EstimatedDeliveryDate';
import { CustomText } from 'components/CustomText';
import { ParcelDetails } from './components/ParcelDetails';

import { Container, NoInfoBox } from './ShipmentDetails.styles';

interface ShipmentDetailsProps {
  shipment: Shipment;
}

export const ShipmentDetails = ({
  shipment,
}: ShipmentDetailsProps): JSX.Element => {
  const { t } = useTranslation();
  const globalConfig = useGlobalConfigContext();

  const {
    rating: { isEnabled: isEnabledRating },
    noInfoUpdate: { messageNoUpdate },
  } = globalConfig.config;
  const isNoInfoUpdateShipment =
    isNoInfoUpdate(shipment) || shipment?.isNoInfoAvailable;

  return (
    <Container {...{ [DEMO_TARGET_ATTRIBUTE]: DEMO_TARGET.confirmSummary }}>
      <EstimatedDeliveryDate parcel={shipment} />

      {isNoInfoUpdateShipment ? (
        <NoInfoBox>
          <CustomText
            as={Typography}
            level="displayMd"
            text={messageNoUpdate || t('NO_INFO_UPDATE_MESSAGE')}
          />
        </NoInfoBox>
      ) : (
        <ParcelDetails shipment={shipment} />
      )}

      {isEnabledRating && (
        <RatingOverall selectedParcel={shipment} globalConfig={globalConfig} />
      )}
    </Container>
  );
};
